import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';

const headers = new HttpHeaders({'Content-Type': 'application/json; charset=utf-8', 'Access-Control-Allow-Origin': '*',
'Access-Control-Allow-Credentials': 'true', 'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'});

@Injectable()
export class MaintenanceService {
   maintenanceUrl = '/superadmin/rest/mgmt/maintenance';

  constructor(private http: HttpClient) { }

  sendAlerts(dataObj): Observable<any> {
    // alert("dataObj"+JSON.stringify(dataObj));
    return this.http.post(this.maintenanceUrl, dataObj, {headers: headers});

  }
  getStatus(): Observable<any> {
    return this.http.get(this.maintenanceUrl, {headers: headers});
  }
  updateStatus(value): Observable<any> {
    return this.http.put(this.maintenanceUrl + '/' + value, {headers: headers});
  }
}
